"use client";

import { useRef } from "react";

/**
 * Tilt card — pointer-tracking 3D tilt, CSS-only (no framer-motion).
 * Imperative style mutation avoids re-renders; `transition` smooths the move
 * like the old spring. Keeping framer-motion out of the landing initial bundle
 * (it's only used by the lazy demo otherwise).
 */
export function TiltCard({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);

  const onMove = (e: React.MouseEvent) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5; // -0.5..0.5
    const py = (e.clientY - r.top) / r.height - 0.5;
    // Tanpa transition selama tracking — interpolasi animasi per mousemove
    // memicu style recalc beruntun; transform langsung cukup smooth di 60Hz
    // pointer events (audit 2026-09-24-landing-performance-audit).
    el.style.transition = "none";
    el.style.transform = `perspective(800px) rotateX(${-py * 8}deg) rotateY(${px * 8}deg)`;
  };

  const onLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.transition = "transform 0.3s ease-out";
    el.style.transform = "perspective(800px) rotateX(0deg) rotateY(0deg)";
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      style={{ transformStyle: "preserve-3d" }}
      className={className}
    >
      {children}
    </div>
  );
}
